<template>
  <div>
    <a-form-model
      :model="form"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      style="margin-top: 10px;"
      :rules="rules"
      ref="ruleForm"
      :key="keyChange"
    >
      <a-form-model-item label="Name / Tên nhóm" prop="name">
        <a-input v-model="form.name" placeholder="Write name..." />
      </a-form-model-item>
    </a-form-model>
    <div
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-button style="margin-right: 10px;" @click="close">
        Close
      </a-button>
      <a-button type="primary" @click="onSubmit" :loading="loading">
        Add New
      </a-button>
    </div>
  </div>
</template>
<script>
import query from "../constant/query";
import moment from "moment";

function range(start, end) {
  var ans = [];

  for (let i = start; i <= end; i++) {
    ans.push(i);
  }
  return ans;
}

const nowYear = new Date().getFullYear();
const listYears = range(+nowYear - 5, +nowYear + 5);
const rules = {
  name: [
    { required: true, message: "Required / Thông tin không được bỏ trống" },
  ],
};
const defaultForm = {};

export default {
  props: {
    close: { type: Function, required: true },
    refreshAfterCreated: { type: Function, required: true },
  },
  data() {
    return {
      listYears,
      rules,
      labelCol: { span: 24 },
      wrapperCol: { span: 24 },
      form: { ...defaultForm },
      loading: false,
      keyChange: 0,
    };
  },
  methods: {
    moment,
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.onCreatedHoliday();
        } else {
          return false;
        }
      });
    },
    onCreatedHoliday() {
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: query.createHelpdeskCategoryGroup,
          variables: {
            ...this.form,
            startDate: this.form.startDate
              ? moment(this.form.startDate).set({
                  hour: 0,
                  minute: 0,
                  second: 0,
                })
              : undefined,
            endDate: this.form.endDate
              ? moment(this.form.endDate).set({
                  hour: 23,
                  minute: 59,
                  second: 59,
                })
              : undefined,
            year: this.form.startDate
              ? +new Date(this.form.startDate).getFullYear()
              : undefined,
          },
        })
        .then(({ data }) => {
          this.$notification.success({
            message: "Success",
            description: "Updated Success!",
          });
          this.loading = false;
          this.form = { ...defaultForm };
          if (data?.createHelpdeskCategoryGroup?.id) {
            this.refreshAfterCreated(data.createHelpdeskCategoryGroup);
          }
          this.keyChange += 1;
        })
        .catch((err) => {
          this.loading = false;
          this.$notification.error({
            message: "Error",
            description: "Updated Error!",
          });
          console.log("Thêm thông tin không thành công", err);
        });
    },
    calTotalDay() {
      if (this.form.startDate && this.form.endDate) {
        const startDate = moment(this.form.startDate).set({
          hour: 0,
          minute: 0,
        });
        const endDate = moment(this.form.endDate).set({ hour: 23, minute: 59 });
        this.$set(this.form, "duration", endDate.diff(startDate, "days") + 1);
      }
    },
    onChangeRangeDate(arrayDate) {
      if (arrayDate) {
        const startDate = arrayDate[0];
        const endDate = arrayDate[1];
        this.$set(this.form, "rangeDate", arrayDate);
        this.$set(this.form, "startDate", startDate);
        this.$set(this.form, "endDate", endDate);
        this.calTotalDay();
      }
    },
  },
};
</script>
<style scoped>
.ict24h-editor >>> .ql-toolbar.ql-snow {
  padding: 2px !important;
}
</style>
